import commonPostTypeConfig from '../../common/postTypes/image'

export default function initPostType({ wapp }) {
    return wapp.client.postTypes.getPostType({
        name: 'file',
        addIfThereIsNot: true,
        statusManager: commonPostTypeConfig.getStatusManager()
    })
}
